var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"pa-6"},[_c('Header'),_c('Sidebar'),_c('v-main',{staticClass:"content"},[_c('Breadcrumbs'),_c('router-view'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }